
import { FBFormModel, FBFormAssignmentModel } from './../../../../models/formBuilderModels';
import { BaseComponent } from './../../../../core/abstracts/baseComponent';
import { BenefitsState } from './../../../../core/store/benefits/benefits.reducer';
import { BenefitPlanModel } from './../../../../models/benefitsModels';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { Component, OnInit, signal, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { Actions, ofType } from '@ngrx/effects';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../../../../shared/services/alert.service';
import { downloadFile, getShortDateFormatted } from '../../../../helpers/utils';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { tap } from 'rxjs';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { createAutoAssignableForm, createAutoAssignableFormSuccess, getAutoAssignableList, getAvailableForms, getFBFormTable, loadFormDoc, loadFormDocSuccess, optOutFormAssignment, toggleFormAssignmentArchived, toggleFormAssignmentArchivedSuccess } from 'src/app/core/store/form-builder/form-builder.actions';
import { FormBuilderService } from '../../../../core/services/formBuilder.service';

@Component({
    selector: 'app-forms-available',
    templateUrl: './forms-available.component.html',
    styleUrls: ['./forms-available.component.scss'],
    standalone: false
})
export class FormsAvailableComponent extends BaseComponent implements OnInit {

  formsList: FBFormAssignmentModel[];
  canEdit: boolean;
  canArchiveDocumentation: boolean;
  loadingAvailableForms = false;
  filter: any;

  yesNoAllOptions = [
    { label: 'All', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  includeArchived?: boolean = false;
  formNameFilter;
  loadingDoc;
  loadingDocAssignmentId;

  autoAssignableForms: SelectItem[];
  loadingAutoAssignable = false;
  savingAuotAssignableForm = false;
  createNewFormId: number = 0;

  managedUserId;
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });
  constructor(
    private actions$: Actions,
    private alertService: AlertService,
    private store: Store<State>,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private dropdownFilterService: DropdownFilterService,
    private formBuilderService: FormBuilderService
  ) {
    super();
  }

  ngOnInit() {
    if (this.route.snapshot.parent.params.userid) {
      this.managedUserId = this.route.snapshot.parent.params.userid;
    }
    this.subs.push(
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 9001);
        this.canArchiveDocumentation = permissionIDs && !!permissionIDs.find(p => p === 9005);
      }),
      this.store.select(s => s.formBuilderState.availableForms).subscribe(availableForms => {
        if (availableForms) {
          this.formsList = availableForms;
          if(availableForms != null)
            this.totalRecords.set(availableForms.length);
        }
      }),

      this.store.select(s => s.formBuilderState.loadingAvailableForms).subscribe(loadingAvailableForms => {
        this.loadingAvailableForms = loadingAvailableForms;
      }),
      this.store.select(s => s.formBuilderState.autoAssignableForms).subscribe(forms => {
        if (forms && forms.length > 0) {
          this.autoAssignableForms = forms.map(x => ({ label: x.label, value: x.value }));          
        }
        else if(this.loadingAutoAssignable) {
          //this.autoAssignableForms = [{ label: 'loading...', value: undefined }];
        }
      }),

      this.store.select(s => s.formBuilderState.loadingAvailableForms).subscribe(loading => {
        this.loadingAutoAssignable = loading;
      }),
      this.store.select(s => s.formBuilderState.savingAuotAssignableForm).subscribe(saving => {
        this.savingAuotAssignableForm = saving;
      }),

      this.store.select(s => s.formBuilderState.loadingDoc).subscribe(loadingDoc => {
        this.loadingDoc = loadingDoc;
      }),
      this.actions$.pipe(
        ofType(loadFormDocSuccess),
        tap(action => {
          downloadFile(action.doc, 'FormSubmission.pdf');
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(toggleFormAssignmentArchivedSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(createAutoAssignableFormSuccess),
        tap(action => {
          this.alertService.success("Form Created!");
          this.reloadList();
        })
      ).subscribe(),
    );

    this.store.dispatch(getAutoAssignableList());
    this.reloadList();
  }  

  reloadList() {
    this.store.dispatch(getAvailableForms({ userID: this.managedUserId, includeArchived: this.includeArchived }));
  }

  toggleArchivedStatus(form: FBFormAssignmentModel) {
    if (!form.id || form.id <= 0 || !this.canToggleArchivedStatus(form)) {
      return;
    }

    const formSubmissionID = form.formSubmission?.id || form.formSubmissionID;
    if (formSubmissionID && !form.archived) {
      this.formBuilderService.getFormSubmissionArchiveImpact(formSubmissionID).subscribe({
        next: (impact) => {
          const archiveReason = window.prompt("Why are you archiving this assignment and its documentation?")?.trim();
          if (!archiveReason) {
            if (archiveReason !== undefined) {
              this.alertService.error("An archive reason is required.");
            }
            return;
          }

          let message = "Archiving this assignment will also archive its form submission and linked assignments.";
          if (impact.affectedFormCount > 1) {
            message += ` Because the form belongs to shared documentation, all ${impact.affectedFormCount} forms will be archived together: ${impact.formNames.join(", ")}.`;
          }

          this.confirmationService.confirm({
            header: "Archive assignment and documentation?",
            message: message,
            acceptLabel: "Archive",
            rejectLabel: "Cancel",
            accept: () => this.store.dispatch(toggleFormAssignmentArchived({
              assignmentId: form.id,
              archiveReason: archiveReason,
            })),
          });
        },
        error: (error) => this.alertService.error(error?.error || "Unable to determine which documentation will be archived."),
      });
      return;
    }

    const restoringDocumentation = form.archived && !!formSubmissionID;
    this.confirmationService.confirm({
      header: restoringDocumentation ? "Restore assignment and documentation?" : `${form.archived ? "Restore" : "Archive"} assignment?`,
      message: restoringDocumentation
        ? "Restoring this assignment will also restore its form submission and any documentation archived with it."
        : `The assignment will be ${form.archived ? "restored" : "archived"}.`,
      acceptLabel: form.archived ? "Restore" : "Archive",
      rejectLabel: "Cancel",
      accept: () => this.store.dispatch(toggleFormAssignmentArchived({ assignmentId: form.id })),
    });
  }

  canToggleArchivedStatus(form: FBFormAssignmentModel) {
    if (this.managedUserId && !this.canEdit) {
      return false;
    }

    const hasLinkedSubmission = !!form?.formSubmissionID || !!form?.formSubmission?.id;
    return !hasLinkedSubmission || !!this.canArchiveDocumentation;
  }

  canArchive(form: FBFormAssignmentModel) {
    if (form.archived || !this.canToggleArchivedStatus(form)) {
      return false;
    }

    if (!form.signatureRequired) {
      return true;
    }

    return this.hasSignedSubmission(form);
  }

  fillForm(form: FBFormAssignmentModel) {
    if (form.formSubmission) {
      this.router.navigate(['../../form-filling/fill/' + form.form.id + '/' + form.formSubmission.id], { relativeTo: this.route });
    } else {
      this.router.navigate(['../../form-filling/fill/' + form.form.id], { relativeTo: this.route });
    }
  }

  fillHRForm(form: FBFormAssignmentModel) {
    const HRQueryParams = { editingAsHR: true };
    if (form.formSubmission) {
      this.router.navigate(['../../form-filling/fill/' + form.form.id + '/' + form.formSubmission.id], { relativeTo: this.route, queryParams: HRQueryParams });
    } else {
      this.router.navigate(['../../form-filling/fill/' + form.form.id], { relativeTo: this.route, queryParams: HRQueryParams });
    }
  }

  signForm(form: FBFormAssignmentModel) {
    if (form.formSubmission) {
      this.router.navigate(['../../form-filling/sign/' + form.formSubmission.id], { relativeTo: this.route });
    }
  }

  optOutForm(form: FBFormAssignmentModel) {
    //Ask for confirmation and then dispatch opt out form
    this.confirmationService.confirm({
      message: 'Are you sure you want to opt out of this form?',
      accept: () => {
        this.store.dispatch(optOutFormAssignment({ assignmentId: form.id }));
      }
    });
  }

  hasSignedSubmission(form: FBFormAssignmentModel) {
    if (form.formSubmission) {
      return form.formSubmission.signedDate;
    }
    return false;
  }

  hasSignedSubmissionHR(form: FBFormAssignmentModel) {
    if (form.formSubmission) {
      return form.formSubmission.signedByHRDate;
    }
    return false;
  }

  getLastDate(form: FBFormAssignmentModel) {
    if (form.formSubmission) {
      return getShortDateFormatted(new Date(form.formSubmission.updatedDate));
    }
    return '-';
  }

  downloadForm(formAssignment: FBFormAssignmentModel) {
    this.loadingDocAssignmentId = formAssignment.id;
    this.store.dispatch(loadFormDoc({ formSubmissionID: formAssignment.formSubmissionID }));
  }

  seeFormResult(formAssignment: FBFormAssignmentModel) {
    this.router.navigate(['../../form-filling/form-submission/' + formAssignment.formID + '/' + formAssignment.formSubmissionID], { queryParams: { backLink: '../../list' }, relativeTo: this.route });
  }

  createNewForm() {
    if (this.createNewFormId > 0) {
      this.store.dispatch(createAutoAssignableForm({ formId: this.createNewFormId }));
    }
    else {
      this.alertService.error("Please select a form.");
    }
  }
}
